import { Box } from '@superdispatch/ui-lab';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { PhoneVerification } from 'shared/modules/phone-verification/PhoneVerification';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';

export function ProfilePhoneVerificationPage() {
  const navigate = useNavigate();

  const onComplete = useCallback(() => {
    navigate('/profile/carrier-info');
  }, [navigate]);

  useDocumentTitle('Phone number verification');

  return (
    <CarrierWebviewHeader>
      <Box padding="small">
        <PhoneVerification onBack={onComplete} onComplete={onComplete} />
      </Box>
    </CarrierWebviewHeader>
  );
}
